var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.625 20H29.375C24.1973 20 20 24.1973 20 29.375V50.625C20 55.8027 24.1973 60 29.375 60H50.625C55.8027 60 60 55.8027 60 50.625V29.375C60 24.1973 55.8027 20 50.625 20Z",
    fill: "#4353FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4227 36.1619C46.4227 36.1619 44.2641 42.9247 44.1045 43.4989C44.0408 42.9353 42.467 30.7812 42.467 30.7812C38.7878 30.7812 36.8313 33.397 35.7891 36.1619C35.7891 36.1619 33.1627 42.9459 32.95 43.5095C32.9394 42.9778 32.5459 36.2256 32.5459 36.2256C32.3225 32.8334 29.2281 30.7812 26.7188 30.7812L29.7387 49.1878C33.588 49.1772 35.6616 46.572 36.7461 43.7967C36.7461 43.7967 39.0536 37.81 39.1494 37.5442C39.1706 37.7994 40.8081 49.1878 40.8081 49.1878C44.6681 49.1878 46.7523 46.7528 47.8688 44.0838L53.2812 30.7812C49.4638 30.7812 47.4541 33.3864 46.4227 36.1619Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebflow);
export default __webpack_public_path__ + "static/media/webflow.67ac4cf531f9681b273184b1bf9cb580.svg";
export { ForwardRef as ReactComponent };